import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IChatbotPublic } from "../../../Components/ChatbotPublic/IChatbotPublic";

export const ExamReadChatbotPublicSlicer = createSlice({
  name: "ExamReadChatbotPublicSlicer",
  initialState: {} as IReduxState<IChatbotPublic>,
  reducers: {
    ExamReadchatbotPublic: (state, _: PayloadAction<IChatbotPublic>) => {
      state.isLoading = true;
    },
    successExamReadChatbotPublic: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureExamReadChatbotPublic: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearExamReadChatbotPublicStatus: (state) => {
      state.data = {};
    },
  },
});

export const {
  ExamReadchatbotPublic,
  successExamReadChatbotPublic,
  failureExamReadChatbotPublic,
  clearExamReadChatbotPublicStatus,
} = ExamReadChatbotPublicSlicer.actions;

export default ExamReadChatbotPublicSlicer.reducer;
